<div class="wms-typeahead-container event-handler" [ngClass]="customClass">

  <input type="text"
         id="input-{{id}}"
         class="full-width"
         spellcheck="false"
         autocomplete="off"
         [(ngModel)]="model"
         (input)="searchOptionsByInput()"
         (click)="textInputFocussed()" />

  <button *ngIf="!openDD" (click)="openDD = !openDD" id="expand-btn-{{id}}" class="wms-typeahead-icon wms wms-arrow-down typeahead-expand-btn" title="{{locale.LABEL_EXPAND.toLowerCase()}}"></button>
  <button *ngIf="openDD" [hidden]="!model" (click)="handleClear()" class="wms-typeahead-icon wms wms-clear typeahead-clear-btn" title="{{locale.LABEL_CLEAR.toLowerCase()}}"></button>

  <ng-container *ngIf="openDD">
    <ul class="wms-typeahead-dropdown">
      <div class="col-xs-12 no-padding group" *ngFor="let option of options">
        <div class="col-xs-12 no-padding ctnr" *ngIf="option.filteredOptions.length">
          <div *ngIf="option.headerTitle" class="header">
            <label [ngClass]="{'col-xs-12 no-padding': !option.subHeaderTitle, 'col-xs-9 no-padding': option.subHeaderTitle}">{{option.headerTitle}}</label>
            <label class="col-xs-3 no-padding text-right" *ngIf="option.subHeaderTitle">{{option.subHeaderTitle}}</label>
          </div>
          <li class="col-xs-12 no-padding uib-typeahead-match" *ngFor="let filteredOption of option.filteredOptions">
            <a class="col-xs-12 no-padding match-item" (click)="handleSelect(filteredOption)">
              <label [ngClass]="{'col-xs-12 no-padding': !subOptionkey, 'col-xs-9 no-padding': subOptionkey}" title="{{filteredOption[optionKey]}}">{{filteredOption[optionKey]}}</label>
              <label class="col-xs-3 no-padding text-right" *ngIf="subOptionkey" title="{{filteredOption[subOptionkey]}}">{{filteredOption[subOptionkey]}}</label>
            </a>
          </li>
        </div>
      </div>
      <p class="no-results" *ngIf="!hasResults && model"><span>{{locale.LABEL_NO_ARTIFACT_MESSAGE}}</span></p>
      <p class="no-results" *ngIf="options.length === 0 && !model"><span>{{message}}</span></p>
    </ul>
  </ng-container>
</div>
